import React from "react";
import BlogCard from "./BlogCard";

const BlogList = ({blogs}) => {
    return (
        <>
            <div className="blog-grid">
                {blogs.map((blog) => (
                    <BlogCard key={blog.slug} blog={blog} />
                ))}
            </div>
        </>
    )
}

export default BlogList;